import { defineMessages } from '@jutro/locale';

export default defineMessages({
    uploadDocument: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Upload Document',
        defaultMessage: 'Upload Document'
    },
    subtitle: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Be sure to select the correct document type',
        defaultMessage: 'Be sure to select the correct document type.'
    },
    typeOfDocument: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Type of document',
        defaultMessage: 'Type of document'
    },
    continue: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Continue',
        defaultMessage: 'Continue'
    },
    cancelModal: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Cancel',
        defaultMessage: 'Cancel'
    },
    date: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Date',
        defaultMessage: 'Date'
    },
    policyNumber: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Policy Number',
        defaultMessage: 'Policy Number'
    },
    accountNumber: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Account Number',
        defaultMessage: 'Account Number'
    },
    category: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Category',
        defaultMessage: 'Category'
    },
    description: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Description',
        defaultMessage: 'Description'
    },
    fullDescription: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Full Description',
        defaultMessage: 'Full Description'
    },
    author: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Author',
        defaultMessage: 'Author'
    },
    noteDetails: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Note Details',
        defaultMessage: 'Note Details'
    },
    closeBtnLabel: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.CLOSE',
        defaultMessage: 'CLOSE'
    },
    invalidFileSize: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Invalid file size. This file will not be uploaded.',
        defaultMessage: 'Invalid file size. This file will not be uploaded.'
    },
    invalidFileType: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Invalid file type. This file will not be uploaded.',
        defaultMessage: 'Invalid file type. This file will not be uploaded.'
    },
    documentSuccess: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.documentSuccess',
        defaultMessage: 'The document uploaded successfully. It may take up to 2 bussiness days for it to show on the document listing'
    },
    othersParagraph: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Please do not upload the Recurring Credit/Debit Card Authorization Form. This form must be mailed or faxed.',
        defaultMessage: 'Please do not upload the Recurring Credit/Debit Card Authorization Form. This form must be mailed or faxed.'
    },
    fileUploadHeader: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.File upload',
        defaultMessage: 'File upload'
    },
    fileUploadSubHeader: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.Documents may take up to 2 business days to display',
        defaultMessage: 'Documents may take up to 2 business days to display'
    },
    fileSeparateUpload: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.When you have more than one document, please upload each document separately.',
        defaultMessage: 'When you have more than one document, please upload each document separately.'
    },
    whenYouHaveMoreThanOneDocument: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.When you have more than one document, please upload each document separately',
        defaultMessage: 'When you have more than one document, please upload each document separately.'
    },
    documentUploadedSuccessfully: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.The document uploaded successfully. It may take up to 2 business days for it to show on the document listing',
        defaultMessage: '<strong>The document uploaded successfully.</strong> It may take up to 2 business days for it to show on the document listing.'
    },
    footerMessage: {
        id: 'ml.claim.views-ml-claim-details-document-upload-dialog.You are about to upload x.  The document cannot be deleted once you click CONTINUE.',
        defaultMessage: 'You are about to upload <strong>{filename}</strong>.  The document cannot be deleted once you click CONTINUE.'
    }
});